import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Observable, of } from "rxjs";
import { environment } from "../../environments/environment";
import { AuthenticationService } from "../../shared/services/authentication.service";
import { ICategory } from "../model/category.model";

@Injectable()
export class CategoryService{
    Categories$!:Observable<ICategory[]>;
    newCategory$!:Observable<ICategory>;
    createdCategory!:ICategory;

    private http = inject(HttpClient);
    authService = inject(AuthenticationService);
    
    getCategories(): Observable<ICategory[]> {
        const token = this.authService.getUserToken();

        let options = { headers: new HttpHeaders( {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`}) };

        if (token !== undefined && token !== null && token !== '') {
            return this.http.get<ICategory[]>( environment.API_URL + '/api/CourseCategory/', options);
        } else {
            return of();
        }    
    }  

    getCategory(id: string|undefined ): Observable<ICategory> {
        const token = this.authService.getUserToken();

        let options = { headers: new HttpHeaders( {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`}) };

        if (token !== undefined && token !== null && token !== '') {
            return this.http.get<ICategory>( environment.API_URL + `/api/CourseCategory/ById/${id}`, options);
        } else {
            return of();
        }    
    }      

    deleteCategory(id: string): Observable<ICategory> {
        const token = this.authService.getUserToken();

        let options = { headers: new HttpHeaders( {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`}) };

        if (token !== undefined && token !== null && token !== '') {
            return this.http.post<ICategory>( environment.API_URL + `/api/CourseCategory/delete/${id}`, options);
        } else {
            return of();
        }    
    }   
    
    createCategory(category: ICategory): Observable<ICategory> {
        const token = this.authService.getUserToken();

        let options = { headers: new HttpHeaders( {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`}) };

        if (token !== undefined && token !== null && token !== '') {
            return this.http.post<ICategory>( environment.API_URL + '/api/CourseCategory/Create', category, options);
        } else {
            return of();
        }    
    }

    editCategory(category: ICategory): Observable<ICategory> {
        const token = this.authService.getUserToken();

        let options = { headers: new HttpHeaders( {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`}) };

        if (token !== undefined && token !== null && token !== '') {
            return this.http.post<ICategory>( environment.API_URL + '/api/CourseCategory/update', category, options);
        } else {
            return of();
        }    
    }    
}